// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13" fill="currentColor">
            <path
                fill="#666"
                fillRule="nonzero"
                d="M11.358 8.248 8.972 7.225a1.07 1.07 0 0 0-1.236.307l-.777.948a7.374 7.374 0 0 1-2.937-2.936l.95-.778c.367-.303.488-.8.3-1.239l-1.02-2.386A1.065 1.065 0 0 0 3.038.527L.824 1.04C.34 1.151 0 1.576 0 2.073 0 7.822 4.678 12.5 10.427 12.5c.498 0 .924-.338 1.036-.823l.51-2.215c.114-.499-.144-1.01-.615-1.214Zm-.626 3.26a.315.315 0 0 1-.304.242C5.09 11.75.75 7.41.75 2.073c0-.145.1-.27.243-.302l2.213-.513a.313.313 0 0 1 .357.18L4.584 3.82a.314.314 0 0 1-.089.366l-1.183.97a.374.374 0 0 0-.099.455 8.118 8.118 0 0 0 3.678 3.677.374.374 0 0 0 .455-.099l.97-1.183a.316.316 0 0 1 .364-.09l2.38 1.02c.14.06.215.21.182.357l-.51 2.215Z"
            />
        </svg>
    );
};

export default React.memo(Phone);
